/* ============================================================
   Raw Formula — upsell Add button
   Adds the suggested bottle via the Ajax Cart API.
   - In the cart DRAWER: re-renders the drawer in place (Dawn's own
     renderContents), so the drawer stays open and the new item +
     ladder/savings update instantly.
   - On the cart PAGE (no open drawer): reloads to show the new item.
   ============================================================ */
(function () {
  if (window.rfUpsellInit) return;
  window.rfUpsellInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Return the cart-drawer element only when the click happened inside it
  // and the theme supports in-place section rendering.
  function drawerFor(btn) {
    var inDrawer = btn.closest && btn.closest('cart-drawer, #CartDrawer, .cart-drawer');
    if (!inDrawer) return null;
    var drawer = document.querySelector('cart-drawer');
    if (
      drawer &&
      typeof drawer.getSectionsToRender === 'function' &&
      typeof drawer.renderContents === 'function'
    ) {
      return drawer;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.rf-add');
    if (!btn) return;
    e.preventDefault();

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    var drawer = drawerFor(btn);
    var body = { items: [{ id: id, quantity: 1 }] };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        // Ajax add error objects carry a `status`; a success line item does not.
        if (res && res.status) {
          btn.disabled = false;
          btn.textContent = label;
          return;
        }
        if (drawer) {
          drawer.renderContents(res); // updates drawer contents + keeps it open
        } else {
          window.location.reload(); // cart page (or no drawer support)
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
